// --------------------------------------------------------------
// Created On: 2024-12-05
// Author: Hannah Vaughan
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./CompanyListRow.module.scss";

// Row listing a company's name and whether it is migrating, a packager, and/or a tester.
export default function CompanyListRow(props: Props): Component {
  return (
    <div className="p-2">
      <span data-test="company-name">{props.name}</span>
      {props.isMigrating && (
        <span data-test="company-is-migrating" className={styles.migratingTag}>
          Migrating
        </span>
      )}
      {props.isPackager && (
        <span data-test="company-is-packager" className={styles.packagerTag}>
          Packager
        </span>
      )}
      {props.isTest && (
        <span data-test="company-is-tester" className={styles.testerTag}>
          Tester
        </span>
      )}
    </div>
  );
}

interface Props {
  companyId: number;
  name: string;
  isMigrating: boolean;
  isPackager: boolean;
  isTest: boolean;
}
